import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { Sketch } from './Sketch';

export const sketchPropertyLayout = LockablePropertyStripLayout<Sketch>((d, s, o, w, a) => [
    //
    // Color - for all strokes in the sketch
    w.createColorSelector({
        groups: true,
        value: a.get('color'),
        text: 'Stroke Color',
        onSelect() {
            o.update(u => {
                u.rolling(a.keyFor('color'));
                a.set('color', this.value!);
            });
        }
    }),
    //
    // Stroke
    w.createSlider({
        value: a.get('thickness'),
        min: 1,
        image: 'deqo://icons/i8/line-width',
        text: 'Thickness',
        onSelect() {
            o.update(() => a.set('thickness', this.value));
        }
    }),
    //
    // Divider
    w.createDivide(),
    //
    // Lock and More
    ...lockAndMoreLayout(d, s, o, w, a),
]);
